import type { IListResponse, ISubjectCharacters } from '@dakedake/types'
import { request } from '@umijs/max'

/** 获取关联详情 GET /backend/subjectCharacters/:id */
export async function subjectCharactersDetail(options?: Record<string, any>) {
  return request<{ data: ISubjectCharacters }>('/backend/subjectCharacters/:id', {
    method: 'GET',
    ...options
  })
}

/** 获取关联角色列表 GET /backend/credits/list */
export async function subjectCharactersList(
  params: {
    // query
    /** 当前的页码 */
    current?: number
    /** 页面的容量 */
    pageSize?: number
    sid?: number
    aid?: number
    order?: 'ASC' | 'DESC'
  },
  options?: Record<string, any>
) {
  return request<IListResponse<ISubjectCharacters>>('/backend/subjectCharacters/list', {
    method: 'GET',
    params,
    ...options
  })
}

/** 添加/编辑关联角色 POST /api/subjectCharacters/add */
export async function subjectCharactersAdd(body: ISubjectCharacters) {
  return request<{ data: ISubjectCharacters, status: number, message: string }>('/backend/subjectCharacters/add', {
    method: 'POST',
    data: body
  })
}

/** 删除关联角色 DELETE /api/subjectCharacters/delete */
export async function subjectCharactersDelete(body: { id?: number }) {
  return request<{ data: number }>('/backend/subjectCharacters/delete', {
    method: 'DELETE',
    data: body
  })
}
